import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { QrCode, Search, ArrowLeft } from "lucide-react";
import QRScanner from "../components/QRScanner";

export default function CheckBalance() {
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [scan, setScan] = useState(false);

  const go = (c) => {
    const val = (c || code).trim().toUpperCase();
    if (val) nav(`/voucher/${val}`);
  };

  return (
    <div className="min-h-screen gp-hero-gradient flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl p-8 w-full max-w-[420px] shadow-2xl">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#5a6b80] hover:text-[#16243b] transition-colors mb-4">
          <ArrowLeft size={16} /> Back to home
        </Link>
        <div className="w-14 h-14 rounded-2xl bg-[#eefafa] flex items-center justify-center mx-auto mb-5">
          <QrCode className="text-[#2ec9c9]" size={28} />
        </div>
        <h1 className="text-2xl font-bold text-[#16243b] text-center">Check your ticket</h1>
        <p className="text-[#5a6b80] text-center mt-2 mb-6">Enter your 10-digit code or scan the QR.</p>
        <form onSubmit={(e) => { e.preventDefault(); go(); }} className="space-y-3">
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} maxLength={10}
            placeholder="e.g. ZE4SYDAXD8"
            className="w-full text-center font-mono tracking-widest text-lg rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 uppercase" />
          <button className="gp-btn-teal w-full rounded-xl py-3 font-medium flex items-center justify-center gap-2">
            <Search size={18} /> Check ticket
          </button>
        </form>
        <button onClick={() => setScan(true)} className="gp-btn-outline w-full rounded-xl py-3 font-medium mt-3 flex items-center justify-center gap-2">
          <QrCode size={18} /> Scan QR code
        </button>
      </div>
      {scan && <QRScanner onResult={(c) => { setScan(false); go(c); }} onClose={() => setScan(false)} />}
    </div>
  );
}
